import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import fileDownload from 'js-file-download';
import * as classnames from 'classnames';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import Grid from '../../../components/base/Grid/Grid';
import {
  dateFormatter, documentListStatusFormatter,
} from '../../../utils/formatters';
import {
  generateDocx, loadAwaitDocument, loadAwaitDocumentClear, loadDocumentById,
} from '../actions';
import { errorNotification } from '../../Notifications/notificationDecorator';
import {
  getPaginationOpts, getResponseError, responseLogWithNotification, useUpdatePeriod,
} from '../../../utils/utils';
import ViewDocument from '../../System/components/ViewDocument';
import { getAwaitDocumentData } from '../reducer';
import { loadFileByUrl } from '../../System/actions';
import Tooltip from '../../../components/base/Tooltip/Tooltip';
import TooltipWithPortal from '../../../components/base/Tooltip/TooltipWithPortal';
import Pagination from '../../../components/base/Pagination/Pagination';
import { APPLICATION_MODULE } from '../../../configs/moduleNames';
import { getSystemData } from '../../System/reducer';

export default function DocumentList(props) {
  const {
    id = '',
    title = '',
    loadData = () => {},
  } = props;
  const {
    currentDocument,
    loadingAwaitDocument,
    awaitDocumentMeta,
    awaitDocument,
  } = useSelector(getAwaitDocumentData);

  const dispatch = useDispatch();
  const [showViewDocument, setShowViewDocument] = useState(false);
  const store = useStore();

  useEffect(() => () => {
    dispatch(loadAwaitDocumentClear());
  }, []);

  const downloadDocument = document => {
    if (!document || !document.file) {
      const { files } = document;
      const signedFile = files.find(f => f.collection_name === 'signed');
      const unsignedFile = files.find(f => f.collection_name === 'unsigned');
      const file = signedFile || unsignedFile;
      dispatch(loadFileByUrl(file.url))
        .then(data => {
          if (data) {
            fileDownload(data, file.file_name);
          }
        })
        .catch(responseLogWithNotification);
    }
  };
  const { updatePeriod } = useSelector(getSystemData);
  const loadDocuments = opts => {
    const paginationOpts = getPaginationOpts(store.getState()[APPLICATION_MODULE].awaitDocumentMeta, opts);
    const requestData = {
      ...paginationOpts,
      filter: {
        source_subject_id: id,
      },
    };
    const p1 = dispatch(loadAwaitDocument(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };

  const [setPeriod] = useUpdatePeriod(loadDocuments, updatePeriod);

  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);

  const handleDownloadDocx = document => {
    dispatch(generateDocx(document.id))
      .then(data => {
        if (data) {
          const templateName = document && document.notification_template && document.notification_template.name;
          const name = `${templateName || document.type_label} ${document.number}.docx`;
          fileDownload(data, name);
        }
      })
      .catch(responseLogWithNotification);
  };

  const viewDocument = id => {
    dispatch(loadDocumentById(id))
      .then(() => setShowViewDocument(true))
      .catch(response => errorNotification('Загрузка документа', getResponseError(response)));
  };

  const nameFormatter = notification_template => {
    const name = notification_template && notification_template.name ? notification_template.name : '';
    return <Tooltip content={name} className={classnames('column-tooltip c300')} />;
  };
  const buttonFormatter = (_, document) => (
    <div className="document-buttons">
      <Button variant="secondary" onClick={() => viewDocument(document.id)}>
        <Icons
          customIcon
          icon="eye-fill"
          className="notification-icon"
        />
      </Button>
      <Button variant="secondary" onClick={() => downloadDocument(document)}>
        <Icons
          customIcon
          icon="download-2"
          className="notification-icon"
        />
      </Button>
      <TooltipWithPortal
        content={(
          <Button variant="secondary">
            <Icons
              customIcon
              icon="download-2"
              className="notification-icon"
            />
          </Button>
        )}
        classNamePortal="more-actions"
        tooltipContent={(
          <div className="more-wrapper">
            <Button variant="link" className="w-100 more-button" onClick={() => downloadDocument(document)}>
              PDF
            </Button>
            <Button variant="link" className="w-100 more-button" onClick={() => handleDownloadDocx(document)}>
              DOC
            </Button>
          </div>
        )}
        classNameWrapper="more-tooltip-wrapper"
        className="more-tooltip"
      />
    </div>
  );

  const rowClassFormatter = row => (row && typeof row.is_actual !== 'undefined' && !row.is_actual ? 'not-actual' : '');

  const columns = [
    {
      dataField: 'created_at',
      text: 'Дата',
      disableSort: true,
      headerClassName: 'created-at',
      formatter: dateFormatter,
    },
    {
      dataField: 'number',
      headerClassName: 'document-number',
      text: 'Номер',
      disableSort: true,
    },
    {
      dataField: 'status',
      text: 'Подпись',
      headerClassName: 'document-status',
      disableSort: true,
      formatter: documentListStatusFormatter,
    },
    {
      dataField: 'notification_template',
      text: 'Наименование',
      headerClassName: 'document-name',
      disableSort: true,
      formatter: nameFormatter,
    },
    {
      dataField: 'status',
      text: 'Действие',
      disableSort: true,
      headerClassName: 'document-button-header',
      formatter: buttonFormatter,
    },
  ];
  return (
    <div className="document-list-block">
      <div className="f4 mb-3">{title}</div>
      <div className="custom-scroll-theme">
        <Grid data={awaitDocument} loading={loadingAwaitDocument} columns={columns} name="profile-list" rowClassFormatter={rowClassFormatter} />
        <div className="null-block" />
        <Pagination meta={awaitDocumentMeta} list={awaitDocument} handleChangeMeta={loadDocuments} />
      </div>
      {showViewDocument && currentDocument
        ? (
          <ViewDocument
            loadData={loadData}
            loadById={viewDocument}
            handleClose={() => setShowViewDocument(false)}
            document={currentDocument}
            loadDocuments={loadDocuments}
            isSignAvailable
            prevCrumbs={(
              <>
                <span className="breadcrumbs-prev">Документы</span>
                <Icons width={22} height={22} customIcon icon="arrow-right" className="breadcrumbs-arrow" />
              </>
            )}
          />
        ) : null}
    </div>
  );
}
